import React from "react";
import {
  Box,
  Heading,
  Text,
  SimpleGrid,
  Image,
  Flex,
  Button,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import solar1 from "../assets/solar (1).jpg";
import solar2 from "../assets/solar (2).jpg";
import solar3 from "../assets/solar (3).jpg";
import solar4 from "../assets/solar (4).jpg";
import solar5 from "../assets/solar (5).jpg";
import solar6 from "../assets/solar (6).jpg";
import WorldMap from "../components/WorldMap";
import projectsbg from "../assets/projectsbg.jpg";

export default function Projects() {
  const MotionBox = motion(Box);

  const projectList = [
    {
      title: "Project 1",
      img: solar1,
      desc: "Solar power plant implementation for industrial sector.",
    },
    {
      title: "Project 2",
      img: solar2,
      desc: "Rooftop solar installation for commercial clients.",
    },
    {
      title: "Project 3",
      img: solar3,
      desc: "Off-grid solar solutions for rural electrification.",
    },
    {
      title: "Project 4",
      img: solar4,
      desc: "Utility-scale solar project with advanced monitoring.",
    },
    {
      title: "Project 5",
      img: solar5,
      desc: "Solar EPC project with optimized efficiency.",
    },
    {
      title: "Project 6",
      img: solar6,
      desc: "Consulting and advisory for solar developers.",
    },
  ];

  return (
    <Box>
      <Box bg="#F5FAF6" color="#305D24">
        {/* Hero Section */}
        <Box
          position="relative"
          shadow="xl"
          minH={{ base: "300px", md: "350px" }}
          overflow="hidden"
        >
          {/* Background Image with overlay */}
          <Box
            position="absolute"
            top={0}
            left={0}
            width="100%"
            height="100%"
            bgImage={`url(${projectsbg})`}
            bgSize="cover"
            bgPosition="center"
            filter="brightness(0.5)   blur(2px)"
            zIndex={0}
          />
          {/* Floating Text Box */}
          <Box
            position="relative"
            zIndex={1}
            color="white"
            p={{ base: 10, md: 16 }}
            pb={0}
            textAlign="center"
          >
            <MotionBox
              initial={{ y: -20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ type: "spring", stiffness: 80 }}
            >
              <Heading
                fontSize={{ base: "3xl", md: "5xl" }}
                mb={4}
                textShadow="2px 2px 4px rgba(0,0,0,0.7)"
              >
                Delivering Excellence Across the Globe
              </Heading>
            </MotionBox>

            <MotionBox
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.2, type: "spring", stiffness: 80 }}
            >
              <Text
                fontSize={{ base: "md", md: "lg" }}
                maxW="3xl"
                mx="auto"
                textShadow="1px 1px 3px rgba(0,0,0,0.6)"
                fontWeight="bold"
              >
                We are committed to deliver extensive services to 150 EPCs,
                developers, and energy consultants across ten countries.
                Industry leaders across US, Canada, East Africa, and India rely
                on us for top-notch turnkey solutions. We work around the clock
                to ensure excellence at every step.
              </Text>
            </MotionBox>
          </Box>
        </Box>

        <WorldMap />

        {/* Call to Action */}
        <Flex justify="center" py={5}>
          <Button
            bg="#FBBF24"
            color="#065F46"
            size="lg"
            as="a"
            href="/contact"
            _hover={{ bg: "#F59E0B" }}
          >
            Start a Project
          </Button>
        </Flex>
      </Box>
    </Box>
  );
}
